// HKDSE 2015 Paper 1 Knowledge Graph Samples - Part 2
// Questions 5-10 from the complete LaTeX file

export const hkdse2015Samples_part2 = {
  inequalities: [
    {
      id: 'hkdse2015_inequalities_01',
      problem: "(a) Find the range of values of $x$ which satisfy both $\\frac{7-3x}{5} \\leq 2(x+2)$ and $4x - 13 > 0$. (b) Write down the smallest integer that satisfies the inequality in part (a).",
      problemType: "inequalities_compound",
      difficulty: "intermediate",
      description: "Solving compound inequalities with integer solutions",
      graphData: {
        nodes: [
          {
            id: "compound_inequalities",
            name: "Compound Inequalities",
            type: "concepts",
            description: "Two inequalities that must both be satisfied",
            value: "Inequality 1 AND Inequality 2",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "inequality1",
            name: "Inequality 1",
            type: "concepts",
            description: "First inequality to solve",
            value: "(7-3x)/5 ≤ 2(x+2)",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "inequality2",
            name: "Inequality 2",
            type: "concepts",
            description: "Second inequality to solve",
            value: "4x - 13 > 0",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step1_solve_ineq1",
            name: "Step 1: Solve Inequality 1",
            type: "steps",
            description: "Solve (7-3x)/5 ≤ 2(x+2)",
            value: "7-3x ≤ 10(x+2) → 7-3x ≤ 10x+20",
            importance: 9,
            x: -200, y: 0, z: 25
          },
          {
            id: "step1a_expand",
            name: "Step 1a: Expand",
            type: "steps",
            description: "Expand and collect terms",
            value: "7-3x ≤ 10x+20 → -13x ≤ 13",
            importance: 8,
            x: -200, y: 50, z: 0
          },
          {
            id: "step1b_solve",
            name: "Step 1b: Solve for x",
            type: "steps",
            description: "Solve the inequality",
            value: "-13x ≤ 13 → x ≥ -1",
            importance: 9,
            x: -200, y: 100, z: 0
          },
          {
            id: "step2_solve_ineq2",
            name: "Step 2: Solve Inequality 2",
            type: "steps",
            description: "Solve 4x - 13 > 0",
            value: "4x > 13 → x > 3.25",
            importance: 8,
            x: 200, y: 0, z: 25
          },
          {
            id: "step3_combine",
            name: "Step 3: Combine Solutions",
            type: "steps",
            description: "Find intersection of both solutions",
            value: "x ≥ -1 AND x > 3.25",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "step4_final_range",
            name: "Step 4: Final Range",
            type: "steps",
            description: "Combine the inequalities",
            value: "x > 3.25",
            importance: 9,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_smallest_integer",
            name: "Part (b): Smallest Integer",
            type: "steps",
            description: "Find smallest integer satisfying x > 3.25",
            value: "Smallest integer = 4",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Range and smallest integer",
            value: "(a) x > 3.25 (b) 4",
            importance: 10,
            x: 0, y: 250, z: 0
          }
        ],
        links: [
          { from: "compound_inequalities", to: "inequality1", type: "includes", strength: 9 },
          { from: "compound_inequalities", to: "inequality2", type: "includes", strength: 9 },
          { from: "inequality1", to: "step1_solve_ineq1", type: "requires", strength: 9 },
          { from: "step1_solve_ineq1", to: "step1a_expand", type: "leads to", strength: 8 },
          { from: "step1a_expand", to: "step1b_solve", type: "leads to", strength: 9 },
          { from: "inequality2", to: "step2_solve_ineq2", type: "requires", strength: 8 },
          { from: "step1b_solve", to: "step3_combine", type: "enables", strength: 9 },
          { from: "step2_solve_ineq2", to: "step3_combine", type: "enables", strength: 9 },
          { from: "step3_combine", to: "step4_final_range", type: "leads to", strength: 9 },
          { from: "step4_final_range", to: "part_b_smallest_integer", type: "enables", strength: 8 },
          { from: "step4_final_range", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_smallest_integer", to: "final_answer", type: "contributes to", strength: 8 }
        ]
      }
    }
  ],
  
  word_problems: [
    {
      id: 'hkdse2015_word_problem_01',
      problem: "The cost of a book is $\\$250$. It is now sold at a profit percentage of $20\\%$. (a) Find the selling price of the book. (b) If the book is sold at a discount of $25\\%$ off the marked price, find the marked price of the book.",
      problemType: "word_problem_percentage_profit",
      difficulty: "intermediate",
      description: "Percentage profit and discount problems",
      graphData: {
        nodes: [
          {
            id: "cost_price",
            name: "Cost Price",
            type: "concepts",
            description: "Cost price of the book",
            value: "CP = $250",
            importance: 8,
            x: -200, y: -200, z: 0
          },
          {
            id: "profit_percentage",
            name: "Profit Percentage",
            type: "concepts",
            description: "20% profit on cost price",
            value: "Profit = 20% of CP",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "part_a_selling_price",
            name: "Part (a): Selling Price",
            type: "steps",
            description: "Calculate selling price with 20% profit",
            value: "SP = CP + Profit = 250 + 0.2×250 = 250 + 50 = $300",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "part_b_discount",
            name: "Part (b): Discount",
            type: "concepts",
            description: "25% discount from marked price",
            value: "SP = 75% of MP",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_b_setup_equation",
            name: "Part (b): Setup Equation",
            type: "steps",
            description: "Set up equation for marked price",
            value: "300 = 0.75 × MP",
            importance: 9,
            x: 0, y: 0, z: 0
          },
          {
            id: "part_b_solve",
            name: "Part (b): Solve for MP",
            type: "steps",
            description: "Solve for marked price",
            value: "MP = 300 ÷ 0.75 = $400",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Selling price and marked price",
            value: "(a) $300 (b) $400",
            importance: 10,
            x: 0, y: 100, z: 0
          }
        ],
        links: [
          { from: "cost_price", to: "profit_percentage", type: "enables", strength: 9 },
          { from: "profit_percentage", to: "part_a_selling_price", type: "enables", strength: 9 },
          { from: "part_a_selling_price", to: "part_b_discount", type: "enables", strength: 9 },
          { from: "part_b_discount", to: "part_b_setup_equation", type: "enables", strength: 9 },
          { from: "part_b_setup_equation", to: "part_b_solve", type: "leads to", strength: 9 },
          { from: "part_a_selling_price", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_solve", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    },
    {
      id: 'hkdse2015_word_problem_02',
      problem: "The number of apples that Pei Ling has is $4$ times that of Chi Wai. If Pei Ling gives $12$ apples to Chi Wai, they will have the same number of apples. Find the total number of apples that Pei Ling and Chi Wai have.",
      problemType: "word_problem_linear",
      difficulty: "intermediate",
      description: "Linear word problem with variables",
      graphData: {
        nodes: [
          {
            id: "initial_condition",
            name: "Initial Condition",
            type: "concepts",
            description: "Pei Ling has 4 times as many apples as Chi Wai",
            value: "Let Chi Wai have x apples, Pei Ling has 4x apples",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "after_transfer",
            name: "After Transfer",
            type: "concepts",
            description: "After Pei Ling gives 12 apples to Chi Wai",
            value: "Chi Wai: x + 12, Pei Ling: 4x - 12",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "final_condition",
            name: "Final Condition",
            type: "concepts",
            description: "They have the same number of apples",
            value: "x + 12 = 4x - 12",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step1_setup_equation",
            name: "Step 1: Setup Equation",
            type: "steps",
            description: "Set up the equation based on final condition",
            value: "x + 12 = 4x - 12",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "step2_collect_terms",
            name: "Step 2: Collect Terms",
            type: "steps",
            description: "Collect like terms",
            value: "24 = 3x",
            importance: 8,
            x: 0, y: 50, z: 0
          },
          {
            id: "step3_solve",
            name: "Step 3: Solve for x",
            type: "steps",
            description: "Solve for x",
            value: "x = 8",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "step4_find_total",
            name: "Step 4: Find Total",
            type: "steps",
            description: "Calculate total apples",
            value: "Total = x + 4x = 5x = 40",
            importance: 10,
            x: 0, y: 150, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Total number of apples",
            value: "40 apples",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "initial_condition", to: "after_transfer", type: "enables", strength: 9 },
          { from: "after_transfer", to: "final_condition", type: "enables", strength: 9 },
          { from: "final_condition", to: "step1_setup_equation", type: "enables", strength: 10 },
          { from: "step1_setup_equation", to: "step2_collect_terms", type: "leads to", strength: 8 },
          { from: "step2_collect_terms", to: "step3_solve", type: "leads to", strength: 9 },
          { from: "step3_solve", to: "step4_find_total", type: "enables", strength: 10 },
          { from: "step4_find_total", to: "final_answer", type: "equals", strength: 10 }
        ]
      }
    }
  ],
  
  circle_geometry: [
    {
      id: 'hkdse2015_circle_01',
      problem: "In Figure 1, $ABCD$ is a circle. $E$ is a point on $AC$ such that $BC = CE$. Given that $AB = AD$, $\\angle ADB = 58°$ and $\\angle CBD = 25°$. Find $\\angle BDC$ and $\\angle ABE$.",
      problemType: "circle_geometry_angles",
      difficulty: "intermediate",
      description: "Circle geometry with angle calculations",
      graphData: {
        nodes: [
          {
            id: "circle_properties",
            name: "Circle Properties",
            type: "concepts",
            description: "ABCD is a circle with given conditions",
            value: "AB = AD, BC = CE, ∠ADB = 58°, ∠CBD = 25°",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "isosceles_triangle",
            name: "Isosceles Triangle",
            type: "concepts",
            description: "AB = AD implies isosceles triangle",
            value: "△ABD is isosceles with AB = AD",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "angle_abd",
            name: "Angle ABD",
            type: "steps",
            description: "Find angle ABD using isosceles triangle",
            value: "∠ABD = ∠ADB = 58°",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "angle_abc",
            name: "Angle ABC",
            type: "steps",
            description: "Find angle ABC",
            value: "∠ABC = ∠ABD + ∠CBD = 58° + 25° = 83°",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "angle_bdc",
            name: "Angle BDC",
            type: "steps",
            description: "Find angle BDC using circle properties",
            value: "∠BDC = 180° - ∠ABC = 180° - 83° = 97°",
            importance: 9,
            x: 0, y: 50, z: 0
          },
          {
            id: "angle_abe",
            name: "Angle ABE",
            type: "steps",
            description: "Find angle ABE using triangle BCE",
            value: "BC = CE implies △BCE is isosceles",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "angle_bce",
            name: "Angle BCE",
            type: "steps",
            description: "Find angle BCE",
            value: "∠BCE = ∠BEC = (180° - ∠ABC)/2 = (180° - 83°)/2 = 48.5°",
            importance: 8,
            x: 0, y: 150, z: 0
          },
          {
            id: "angle_abe_final",
            name: "Angle ABE Final",
            type: "steps",
            description: "Find angle ABE",
            value: "∠ABE = ∠ABC - ∠CBE = 83° - 48.5° = 34.5°",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Both required angles",
            value: "∠BDC = 97°, ∠ABE = 34.5°",
            importance: 10,
            x: 0, y: 250, z: 0
          }
        ],
        links: [
          { from: "circle_properties", to: "isosceles_triangle", type: "enables", strength: 9 },
          { from: "isosceles_triangle", to: "angle_abd", type: "enables", strength: 8 },
          { from: "angle_abd", to: "angle_abc", type: "enables", strength: 8 },
          { from: "angle_abc", to: "angle_bdc", type: "enables", strength: 9 },
          { from: "circle_properties", to: "angle_abe", type: "enables", strength: 8 },
          { from: "angle_abe", to: "angle_bce", type: "enables", strength: 8 },
          { from: "angle_bce", to: "angle_abe_final", type: "enables", strength: 9 },
          { from: "angle_bdc", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "angle_abe_final", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  mensuration: [
    {
      id: 'hkdse2015_mensuration_01',
      problem: "The radius and area of a sector are $12$ cm and $30\\pi$ cm$^2$ respectively. (a) Find the angle of the sector. (b) Express the perimeter of the sector in terms of $\\pi$.",
      problemType: "mensuration_sector",
      difficulty: "intermediate",
      description: "Sector area and perimeter calculations",
      graphData: {
        nodes: [
          {
            id: "sector_properties",
            name: "Sector Properties",
            type: "concepts",
            description: "Sector with given radius and area",
            value: "Radius = 12 cm, Area = 30π cm²",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "sector_area_formula",
            name: "Sector Area Formula",
            type: "formulas",
            description: "Area of sector formula",
            value: "A = (θ/360°) × πr²",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "part_a_setup_equation",
            name: "Part (a): Setup Equation",
            type: "steps",
            description: "Set up equation for angle",
            value: "30π = (θ/360°) × π × 12²",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "part_a_simplify",
            name: "Part (a): Simplify",
            type: "steps",
            description: "Simplify the equation",
            value: "30π = (θ/360°) × 144π",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_a_solve",
            name: "Part (a): Solve for θ",
            type: "steps",
            description: "Solve for the angle",
            value: "30 = (θ/360°) × 144 → θ = 75°",
            importance: 9,
            x: 0, y: 50, z: 0
          },
          {
            id: "part_b_perimeter",
            name: "Part (b): Perimeter",
            type: "concepts",
            description: "Perimeter of sector formula",
            value: "P = 2r + (θ/360°) × 2πr",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_b_calculate",
            name: "Part (b): Calculate",
            type: "steps",
            description: "Calculate perimeter",
            value: "P = 2×12 + (75°/360°) × 2π×12 = 24 + 5π",
            importance: 9,
            x: 0, y: 150, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Angle and perimeter",
            value: "(a) 75° (b) 24 + 5π cm",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "sector_properties", to: "sector_area_formula", type: "enables", strength: 9 },
          { from: "sector_area_formula", to: "part_a_setup_equation", type: "enables", strength: 9 },
          { from: "part_a_setup_equation", to: "part_a_simplify", type: "leads to", strength: 8 },
          { from: "part_a_simplify", to: "part_a_solve", type: "leads to", strength: 9 },
          { from: "part_a_solve", to: "part_b_perimeter", type: "enables", strength: 9 },
          { from: "part_b_perimeter", to: "part_b_calculate", type: "enables", strength: 9 },
          { from: "part_a_solve", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_calculate", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  functions: [
    {
      id: 'hkdse2015_functions_01',
      problem: "When Aunt Sue sells $n$ handbags in a certain month, her income for that month is $\\$S$. It is known that $S$ is the sum of two parts, one part is a constant, and the other part varies directly as $n$. When $n = 10$, $S = 10600$; when $n = 6$, $S = 9000$. (a) When Aunt Sue sells $20$ handbags in a certain month, find her income for that month. (b) When Aunt Sue sells a certain number of handbags in a certain month, is it possible for her income for that month to be $\\$18000$? Explain your answer.",
      problemType: "functions_variation",
      difficulty: "intermediate",
      description: "Function with constant and variable parts",
      graphData: {
        nodes: [
          {
            id: "function_structure",
            name: "Function Structure",
            type: "concepts",
            description: "S has constant and variable parts",
            value: "S = c + kn",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "given_points",
            name: "Given Points",
            type: "concepts",
            description: "Two points on the function",
            value: "n = 6, S = 9000; n = 10, S = 10600",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "step1_setup_equations",
            name: "Step 1: Setup Equations",
            type: "steps",
            description: "Set up system of equations",
            value: "9000 = c + 6k, 10600 = c + 10k",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "step2_solve_system",
            name: "Step 2: Solve System",
            type: "steps",
            description: "Solve the system of equations",
            value: "Subtract: 1600 = 4k → k = 400",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "step3_find_c",
            name: "Step 3: Find c",
            type: "steps",
            description: "Find the constant term",
            value: "c = 9000 - 6×400 = 6600",
            importance: 8,
            x: 0, y: 50, z: 0
          },
          {
            id: "step4_write_function",
            name: "Step 4: Write Function",
            type: "steps",
            description: "Write the complete function",
            value: "S = 6600 + 400n",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_a_find_s20",
            name: "Part (a): Find S(20)",
            type: "steps",
            description: "Calculate S when n = 20",
            value: "S = 6600 + 400×20 = 14600",
            importance: 9,
            x: 0, y: 150, z: 0
          },
          {
            id: "part_b_check_18000",
            name: "Part (b): Check $18000",
            type: "steps",
            description: "Check if S = 18000 is possible",
            value: "18000 = 6600 + 400n → n = 28.5",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_conclusion",
            name: "Part (b): Conclusion",
            type: "steps",
            description: "Since n must be integer, not possible",
            value: "n = 28.5 is not an integer, so not possible",
            importance: 9,
            x: 0, y: 250, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Income and possibility",
            value: "(a) $14600 (b) No, n must be integer",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "function_structure", to: "given_points", type: "enables", strength: 9 },
          { from: "given_points", to: "step1_setup_equations", type: "enables", strength: 9 },
          { from: "step1_setup_equations", to: "step2_solve_system", type: "leads to", strength: 9 },
          { from: "step2_solve_system", to: "step3_find_c", type: "leads to", strength: 8 },
          { from: "step3_find_c", to: "step4_write_function", type: "leads to", strength: 9 },
          { from: "step4_write_function", to: "part_a_find_s20", type: "enables", strength: 9 },
          { from: "step4_write_function", to: "part_b_check_18000", type: "enables", strength: 8 },
          { from: "part_b_check_18000", to: "part_b_conclusion", type: "leads to", strength: 9 },
          { from: "part_a_find_s20", to: "final_answer", type: "contributes to", strength: 9 },
          { from: "part_b_conclusion", to: "final_answer", type: "contributes to", strength: 9 }
        ]
      }
    }
  ]
}; 